<template>
  <div ref="container" class="lottie-wrapper" :style="{ width, height }"></div>
</template>

<script>
import lottie from "lottie-web";
// 移除这个导入，因为它会影响全局布局
// import { setupRemResizeListener } from "@/utils/largescreen/rem";

export default {
  name: "LottiePlayer",
  props: {
    src: { type: [String, Object], required: true },
    width: { type: String, default: "0px" },
    height: { type: String, default: "0px" },
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: true },
  },
  data() {
    return {
      animation: null,
      // 移除rem监听相关变量
      // cleanupRemListener: null,
      resizeHandler: null, // 屏幕 resize 触发缩放的监听
      resizeTimeout: null, // 防抖用定时器
    };
  },
  mounted() {
    this.initAnimation();

    // 移除rem监听，避免影响全局布局
    // this.cleanupRemListener = setupRemResizeListener();

    // 绑定窗口 resize，触发 lottie 缩放，防抖处理
    this.resizeHandler = () => {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.scaleSVG();
      }, 100);
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.removeEventListener(
        "complete",
        this.handleAnimationComplete
      );
      this.animation.removeEventListener("DOMLoaded", this.scaleSVG);
      this.animation.destroy();
      this.animation = null;
    }

    // 移除rem监听清理
    // if (this.cleanupRemListener) {
    //   this.cleanupRemListener();
    //   this.cleanupRemListener = null;
    // }

    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = null;
    }
  },
  methods: {
    initAnimation() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.container,
        renderer: "svg",
        loop: false,
        autoplay: this.autoplay,
        path: typeof this.src === "string" ? this.src : undefined,
        animationData: typeof this.src === "object" ? this.src : undefined,
      });

      this.animation.addEventListener("data_ready", () => {
        this.setSize();
      });

      this.animation.addEventListener("DOMLoaded", this.scaleSVG);
      this.animation.addEventListener("complete", this.handleAnimationComplete);
    },

    setSize() {
      const data = this.animation?.animationData;
      if (data && this.width === "0px" && this.height === "0px") {
        this.$refs.container.style.width = `${data.w}px`;
        this.$refs.container.style.height = `${data.h}px`;
      }
    },

    handleAnimationComplete() {
      if (this.loop) {
        this.animation.goToAndPlay(0, true);
      }
    },

    scaleSVG() {
      const container = this.$refs.container;
      const svg = container.querySelector("svg");
      const data = this.animation?.animationData;

      if (!svg || !data) return;

      const rawW = data.w || 24;
      const rawH = data.h || 24;

      const widthPx = this.toPx(this.width, rawW);
      const heightPx = this.toPx(this.height, rawH);

      const scaleX = widthPx / rawW;
      const scaleY = heightPx / rawH;

      svg.style.transform = `scale(${scaleX}, ${scaleY})`;
      svg.style.transformOrigin = "top left";
      svg.style.position = "absolute";
      svg.style.top = "0";
      svg.style.left = "0";
      svg.style.width = `${rawW}px`;
      svg.style.height = `${rawH}px`;
    },

    toPx(length, fallback = 24) {
      if (!length || length === "0px") return fallback;
      if (length.endsWith("px")) {
        return parseFloat(length);
      } else if (length.endsWith("rem")) {
        const value = parseFloat(length);
        const fontSize =
          parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        return value * fontSize;
      }
      return fallback;
    },
  },
};
</script>

<style scoped>
.lottie-wrapper {
  position: relative;
  overflow: hidden;
}
</style>
